import { useIsVertical } from '@cloud/shared/ui'

import type { ReactNode } from 'react'

import { SidebarProvider } from '@/components/ui/sidebar'
import { useRealtimeInvalidation } from '@/hooks/useRealtimeInvalidation'

import { Customizer } from './customizer'
import { HorizontalLayout } from './horizontal-layout'
import { VerticalLayout } from './vertical-layout'

export function Layout({ children }: { children: ReactNode }) {
  const isVertical = useIsVertical()

  // Connect to the real-time WebSocket for automatic cache invalidation.
  // When another user modifies data in the same tenant, the WS pushes
  // an invalidation signal and TanStack Query refetches the affected
  // queries — no page refresh needed.
  useRealtimeInvalidation()

  // SidebarProvider renders a full-page layout `<div>` wrapper, so it
  // only belongs on dashboard pages that actually render a sidebar.
  // Mounting it at app root would force every public page (/login,
  // /404, etc.) into the sidebar layout scaffold.
  return (
    <SidebarProvider>
      <Customizer />
      {isVertical ? (
        <VerticalLayout>{children}</VerticalLayout>
      ) : (
        <HorizontalLayout>{children}</HorizontalLayout>
      )}
    </SidebarProvider>
  )
}
